"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _splitToWords2 = _interopRequireDefault(require("./splitToWords"));

/*
  This function just gives us a count of cells (columns or rows).
 */
var lengthOf = function lengthOf(value) {
  var _splitToWords;

  return value ? (_splitToWords = (0, _splitToWords2.default)(value)) === null || _splitToWords === void 0 ? void 0 : _splitToWords.length : undefined;
};

var _default = lengthOf;
exports.default = _default;